export default [
  {
    header: "HYDRA MANT",
    resource: "HM Maquina",
    action: "menu",
  },
  {
    title: "HYDRA MANTENIMIENTO",
    icon: "LayersIcon",
    children: [
      // {
      //   title: "Sociedad",
      //   route: "hydra_maquina_sociedad",
      //   icon: "BoxIcon",
      //   resource: "HM Sociedad",
      //   action: "menu",
      //
      // },
      {
        title: "Maquina",
        route: "hydra_maquina",
        icon: "BoxIcon",
        resource: "HM Maquina",
        action: "menu",

      },
      {
        title: "Maquina Variedad",
        route: "hydra_maquina_variedad",
        icon: "BoxIcon",
        resource: "HM Maquina Variedad",
        action: "menu",

      },
      {
        title: "Formatos",
        route: "hydra_formatos",
        icon: "BoxIcon",
        resource: "HM Formatos",
        action: "menu",

      },
      {
        title: "Categorizacion",
        route: "hydra_categorizacion",
        icon: "BoxIcon",
        resource: "HM Categorizacion",
        action: "menu",

      },
      {
        title: "Defectos",
        route: "hydra_defectos",
        icon: "BoxIcon",
        resource: "HM Defectos",
        action: "menu",

      },
      {
        title: "Categoria evaluacion",
        route: "categoria_evaluacion",
        icon: "BoxIcon",
        resource: "HM Categoria evaluacion",
        action: "menu",

      },
      {
        title: "Formato-Defectos",
        route: "hydra_formato_defectos",
        icon: "BoxIcon",
        resource: "HM Formato Defectos",
        action: "menu",

      },
      {
        title: "Correlacion",
        route: "correlacion",
        icon: "BoxIcon",
        resource: "HM Correlacion",
        action: "menu",

      },
      {
        title: "Tolerancia",
        route: "tolerancia",
        icon: "BoxIcon",
        resource: "HM Tolerancia",
        action: "menu",
      },
    ],
  },
];
